import axios from 'axios';
import {
  getPremioAdminToken,
  invalidatePremioAdminToken,
} from './premioAdminToken';

const baseURL = process.env.REACT_APP_EXTERNAL_API_BASE_URL;

if (!baseURL) {
  // eslint-disable-next-line no-console
  console.warn('[externalRequest] No se definió REACT_APP_EXTERNAL_API_BASE_URL ni VITE_API_BASE_URL');
}

const externalClient = axios.create({
  baseURL,
});

const withAuthorization = (config, token) => ({
  ...config,
  headers: {
    ...config.headers,
    Authorization: `Bearer ${token}`,
  },
});

const normalizeError = (error) => {
  if (error && error.response) {
    return error.response;
  }

  return (error && error.message) || error;
};

const externalRequest = async (options = {}) => {
  const { private: isPrivate, ...config } = options;

  try {
    if (!isPrivate) {
      return await externalClient(config);
    }

    const token = await getPremioAdminToken();

    try {
      return await externalClient(withAuthorization(config, token));
    } catch (error) {
      if (!error.response || error.response.status !== 401) {
        throw error;
      }

      invalidatePremioAdminToken(token);
      const refreshedToken = await getPremioAdminToken();

      return await externalClient(withAuthorization(config, refreshedToken));
    }
  } catch (error) {
    return Promise.reject(normalizeError(error));
  }
};

export default externalRequest;
